import React, { useMemo } from 'react';
import styles from './GetAccessCode.module.scss';
import Button from '../../Button';
import useFacialRecognition from './useFacialRecognition';
import Spinner from '../../Spinner';

export default function FacialRecognitionForm({ onAttach = () => {}, onContinue = () => {}, onSubmit = () => {} }) {
  const {
    attachedFile,
    handleSubmit,
    handleContinue,
    isSubmitting,
    ref,
    setAttachedFile,
    setStudentImageFile,
    studentImageFile,
    studentImage,
    noStudentFound,
  } = useFacialRecognition();

  const previewUrl = useMemo(() => {
    if (!attachedFile) return null;

    return URL.createObjectURL(attachedFile);
  }, [attachedFile]);

  return (
    <>
      {noStudentFound && (
        <div className={`${styles.submittingSection} ${styles.error}`}>
          <p>We&apos;re sorry, but no student was found with the given information or provided image.</p>
          <p>We&apos;ll look up your student with the information provided and get back to you</p>
        </div>
      )}
      {isSubmitting && (
        <div className={styles.submittingSection}>
          <Spinner color="blue" />
          We are searching for your student
        </div>
      )}
      {studentImage && studentImage.student && (
        <div className={`${styles.submittingSection} ${styles.success}`}>
          <p>
            Press continue to begin purchasing pictures for
            {` ${studentImage.student.firstName} ${studentImage.student.lastName}`}
          </p>
        </div>
      )}
      <div className={styles.section}>
        {!studentImage && (
          <label className={styles.fileField} htmlFor="studentImageUpload">
            Click To Attach Image
            <input
              disabled={isSubmitting}
              ref={ref}
              id="studentImageUpload"
              type="file"
              name="studentImage"
              accept="image/*"
              onChange={() => {
                setStudentImageFile(true);
                setAttachedFile(ref.current.files[0]);
                onAttach();
              }}
            />
          </label>
        )}
        {studentImageFile && !studentImage && (
          <Button
            fullWidth
            rounded
            type="button"
            variant="submit"
            onClick={() => {
              onSubmit();
              handleSubmit();
            }}
            disabled={isSubmitting}
          >
            Submit
          </Button>
        )}

        {studentImageFile && studentImage && (
          <Button
            fullWidth
            rounded
            type="button"
            variant="submit"
            onClick={() => {
              if (onContinue) onContinue();
              handleContinue(studentImage);
            }}
            disabled={isSubmitting}
          >
            Continue
          </Button>
        )}
        {previewUrl && <img alt="Preview of uploaded file" className={styles.previewImage} src={previewUrl.toString()} />}
      </div>
    </>
  );
}
